import { render } from "./ImageIdentifier.vue?vue&type=template&id=efd182e6"
import script from "./ImageIdentifier.vue?vue&type=script&lang=js"
export * from "./ImageIdentifier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__